import { FC } from 'react';
import { RebateCoProducts } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface RebateTagTooltipProps {
    reason: RebateCoProducts['value']['rebateReason'];
}

const RebateTagTooltip: FC<RebateTagTooltipProps> = ({ reason }) => (
    <>
        <LocalizedText textKey={TextKey.Reason} />: {reason}
    </>
);

export default RebateTagTooltip;
